// muted colours for the initials tile of templates and processes, picked by title so a
// template and its processes keep the same colour everywhere
const TILE_COLORS = [
  ['#E6F0FB', '#0050A0'], ['#E8F5EE', '#1E7A4C'], ['#FDF0E6', '#A4520F'], ['#F1ECFB', '#5B3BA8'],
  ['#E6F5F7', '#0E6E7A'], ['#FCEBEE', '#A3263F'], ['#F3F4E4', '#646B12'], ['#ECEFF3', '#3D4A5C']
]

export function tileColors(title: string) {
  let hash = 0
  for (let i = 0; i < title.length; i += 1) hash = (hash * 31 + title.charCodeAt(i)) % 9973
  return TILE_COLORS[hash % TILE_COLORS.length]
}

export function initials(title: string) {
  const words = title.replace(/[^\p{L}\p{N} ]/gu, ' ').split(/\s+/).filter(Boolean)
  return (words.length > 1 ? words[0][0] + words[1][0] : (words[0] ?? '?').slice(0, 2)).toUpperCase()
}
